import { render, staticRenderFns } from "./SendVerification.vue?vue&type=template&id=2ea10027&scoped=true"
import script from "./SendVerification.vue?vue&type=script&lang=js"
export * from "./SendVerification.vue?vue&type=script&lang=js"
import style0 from "./SendVerification.vue?vue&type=style&index=0&id=2ea10027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea10027",
  null
  
)

export default component.exports